import { NotificationService } from 'src/app/shared/services/notification.service';
import { inject, Component, OnInit, ViewEncapsulation } from '@angular/core';
import {
  FoodSafetyManualCompleteChecklistData,
  FoodSafteyManualCompleteStatus,
  FoodSafetyManualCompleteChecklist
} from '../models/complete-checklist';
import { CompleteCheckListServices } from '../services/complete-checklist.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseServices } from '../../kuba.services';
import { Location } from '@angular/common';
import { ManualControlServices } from 'src/app/kuba/manual-control/services/manual-control-services';
import { FoodSafetyServices } from 'src/app/kuba/foodsafety/services/foodsafety.services';
import { ConfirmationService } from 'primeng/api';
import { InputNumber } from 'primeng/inputnumber';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, Subject, debounceTime } from 'rxjs';
import { FeatureKey, Status } from 'src/app/_models';
@Component({
  selector: 'app-kuba-foodsafety-complete-checklist',
  templateUrl: './kuba-foodsafety-complete-checklist.component.html',
  styleUrls: ['./kuba-complete-checklist.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class FoodSafetyCompleteChecklistComponent implements OnInit {
  private readonly notifications = inject(NotificationService);

  FoodSafetyManualCompleteChecklist: FoodSafetyManualCompleteChecklist;
  FoodSafetyManualCompleteChecklistData: FoodSafetyManualCompleteChecklistData[];
  temperaturevalue: any;
  featureKey: number;
  key: any;
  featureId: any;
  showLoader = false;
  zoneTitle: string;
  private subscriptions: Subscription[] = [];
  checkpointPage = 0;
  MathMin = Math.min;
  checkpointFilter: 'all' | 'unanswered' | 'deviations' = 'all';
  draftSaving = false;
  draftStatus = '';

  private draftVersion = 0;
  private readonly draftChanges = new Subject<void>();
  get checkpoints() {
    return this.FoodSafetyManualCompleteChecklistData ?? [];
  }

  get answered(): number {
    return this.checkpoints.filter(item =>
      item.Status?.some(status => status.Value)
    ).length;
  }

  get checkpointPages(): number[] {
    return Array.from(
      { length: Math.ceil(this.checkpoints.length / 10) },
      (_, i) => i
    );
  }

  get sectionCheckpoints() {
    return this.checkpoints.length >= 25
      ? this.checkpoints.slice(
          this.checkpointPage * 10,
          this.checkpointPage * 10 + 10
        )
      : this.checkpoints;
  }

  get visibleCheckpoints() {
    return this.sectionCheckpoints.filter(
      item =>
        this.checkpointFilter === 'all' ||
        (this.checkpointFilter === 'unanswered'
          ? !item.Status?.some(status => status.Value)
          : item.Status?.[2]?.Value)
    );
  }

  constructor(
    private CompleteCheckListServices: CompleteCheckListServices,
    private route: ActivatedRoute,
    public foodSafetyService: FoodSafetyServices,
    private manualControlService: ManualControlServices,
    private Location: Location,
    private confirmationService: ConfirmationService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.draftChanges
        .pipe(debounceTime(1500))
        .subscribe(() => this.saveDraft())
    );
    let workingModule = JSON.parse(sessionStorage.getItem('workingModule'))?.id;
    if (workingModule != null) {
      this.featureId = workingModule;
      if (this.featureId === FeatureKey.FOOD_SAFETY) this.key = 'foodsafety';
      else if (this.featureId === FeatureKey.KUBA_CONTROL)
        this.key = 'kubacontrol';
    }
    let path = this.route.snapshot.url[1].path;
    if (path === 'new') {
      if (this.route.snapshot.params['FeatureKey'] !== 'null') {
        this.FoodSafetyManualCompleteChecklistData = [];
        this.subscriptions.push(
          this.CompleteCheckListServices.GetFoodSafetyChecklistDataByFoodId(
            this.route.snapshot.params['FeatureKey'],
            this.key
          ).subscribe((result: any) => {
            if (result) {
              this.FoodSafetyManualCompleteChecklist =
                new FoodSafetyManualCompleteChecklist();
              this.FoodSafetyManualCompleteChecklist.FeatureId = this.featureId;
              this.FoodSafetyManualCompleteChecklist.FeatureKey = Number(
                this.route.snapshot.params['FeatureKey']
              );
              this.FoodSafetyManualCompleteChecklist.BusinessId =
                BaseServices.BusinessId;
              this.FoodSafetyManualCompleteChecklist.Id = 0;
              this.FoodSafetyManualCompleteChecklist.CreatedBy =
                BaseServices.UserId;
              this.featureKey = Number(
                this.route.snapshot.params['FeatureKey']
              );
              this.FoodSafetyManualCompleteChecklistData = JSON.parse(result);
              this.FoodSafetyManualCompleteChecklist.CheckListData = result;
              this.FoodSafetyManualCompleteChecklistData.forEach(
                (element: any) => {
                  let totalMinAndMaxTemp =
                    Number(element.MinTemp) + Number(element.MaxTemp);
                  let calculatedTemp = totalMinAndMaxTemp / 2;
                  element.Temperature = calculatedTemp;
                }
              );
            }
          })
        );
      } else {
        this.FoodSafetyManualCompleteChecklistData = [];
        this.subscriptions.push(
          this.CompleteCheckListServices.GetAllFoodSafetyChecklistData(
            this.key
          ).subscribe((result: any) => {
            if (result) {
              this.FoodSafetyManualCompleteChecklist =
                new FoodSafetyManualCompleteChecklist();
              this.FoodSafetyManualCompleteChecklist.FeatureId = this.featureId;
              this.FoodSafetyManualCompleteChecklist.FeatureKey = null;
              this.FoodSafetyManualCompleteChecklist.BusinessId =
                BaseServices.BusinessId;
              this.FoodSafetyManualCompleteChecklist.Id = 0;
              this.FoodSafetyManualCompleteChecklist.CreatedBy =
                BaseServices.UserId;
              this.featureKey = null;
              this.FoodSafetyManualCompleteChecklistData = JSON.parse(result);
              this.FoodSafetyManualCompleteChecklistData.forEach(
                (element: any) => {
                  let totalMinAndMaxTemp =
                    Number(element.MinTemp) + Number(element.MaxTemp);
                  let calculatedTemp = totalMinAndMaxTemp / 2;
                  element.Temperature = calculatedTemp;
                }
              );
              this.FoodSafetyManualCompleteChecklist.CheckListData = result;
              this.FoodSafetyManualCompleteChecklist.CheckListData = result;
            }
          })
        );
      }
    } else {
      this.FoodSafetyManualCompleteChecklistData = [];
      this.CompleteCheckListServices.getFoodSafetyChecklistById(
        this.route.snapshot.params['clId'],
        this.key
      ).subscribe((result: any) => {
        if (result) {
          this.featureKey = result.FeatureKey;
          this.FoodSafetyManualCompleteChecklist = result;
          this.FoodSafetyManualCompleteChecklistData = JSON.parse(
            this.FoodSafetyManualCompleteChecklist.CheckListData
          );
          this.FoodSafetyManualCompleteChecklistData.forEach((element: any) => {
            element.Temperature = element.Temperature;
          });
        }
      });
    }
    this.zoneTitle = sessionStorage.getItem('ZoneName');
  }

  setStatus(
    event: FoodSafteyManualCompleteStatus,
    status: FoodSafteyManualCompleteStatus[]
  ) {
    for (let statusitem of status) {
      if (statusitem.Type == event.Type) {
        statusitem.Value = true;
      } else {
        statusitem.Value = false;
      }
    }
    this.queueDraft();
  }

  firstUnanswered(): void {
    const index = this.checkpoints.findIndex(
      item => !item.Status?.some(status => status.Value)
    );
    if (index < 0) return;
    this.checkpointPage = Math.floor(index / 10);
    this.checkpointFilter = 'unanswered';
  }

  markRestNa(): void {
    for (const item of this.sectionCheckpoints) {
      if (!item.Status?.some(status => status.Value) && item.Status?.[1])
        this.setStatus(item.Status[1], item.Status);
    }
  }

  queueDraft(): void {
    this.draftVersion++;
    this.draftStatus = 'CHECKLIST_REDESIGN.UNSAVED';
    this.draftChanges.next();
  }

  /**
   * Lets the temperature field accept both "," and "." as the decimal separator.
   * PrimeNG only accepts the locale's own separator, so the other one is inserted
   * as the locale separator instead of the browser's keypress.
   */
  onTemperatureKeyDown(event: KeyboardEvent, input: InputNumber): void {
    const isSeparator = event.key === ',' || event.key === '.';
    if (!isSeparator || event.key === input._decimalChar) {
      return;
    }
    event.preventDefault();
    input.insert(event, input._decimalChar, {
      isDecimalSign: true,
      isMinusSign: false
    });
  }

  private saveDraft(): void {
    if (
      this.draftSaving ||
      this.showLoader ||
      !this.FoodSafetyManualCompleteChecklist
    )
      return;
    const version = this.draftVersion;
    this.draftSaving = true;
    this.draftStatus = 'CHECKLIST_REDESIGN.SAVING_DRAFT';
    const snapshot = {
      ...this.FoodSafetyManualCompleteChecklist,
      FeatureKey: this.FoodSafetyManualCompleteChecklist.FeatureKey || 0,
      Title:
        this.FoodSafetyManualCompleteChecklist.Title ||
        this.zoneTitle ||
        this.translate.instant('COMPLETE_MANUAL_CONTROL'),
      CreatedBy:
        this.FoodSafetyManualCompleteChecklist.CreatedBy || BaseServices.UserId,
      ModifiedBy: BaseServices.UserId,
      CheckListData: JSON.stringify(this.checkpoints)
    };
    this.subscriptions.push(
      this.CompleteCheckListServices.saveTemperatureDraft(
        this.featureId === FeatureKey.KUBA_CONTROL ? 'control' : 'food',
        snapshot
      ).subscribe({
        next: (result: any) => {
          this.FoodSafetyManualCompleteChecklist.Id = result;
          this.FoodSafetyManualCompleteChecklist.Title = snapshot.Title;
          this.FoodSafetyManualCompleteChecklist.Status = Status.Active;
          this.draftSaving = false;
          this.draftStatus =
            version === this.draftVersion
              ? 'CHECKLIST_REDESIGN.DRAFT_SAVED'
              : 'CHECKLIST_REDESIGN.UNSAVED';
          if (version !== this.draftVersion) this.draftChanges.next();
        },
        error: () => {
          this.draftSaving = false;
          this.draftStatus = 'CHECKLIST_REDESIGN.DRAFT_ERROR';
        }
      })
    );
  }

  SaveCompleteCheckList() {
    this.showLoader = true;
    let CultureInfo = sessionStorage.getItem('languageMode');
    this.FoodSafetyManualCompleteChecklist.ModifiedBy = BaseServices.UserId;
    this.FoodSafetyManualCompleteChecklist.CheckListData = JSON.stringify(
      this.FoodSafetyManualCompleteChecklistData
    );
    this.CompleteCheckListServices.SaveFoodSafetyChecklistById(
      this.FoodSafetyManualCompleteChecklist,
      CultureInfo,
      this.key
    ).subscribe(result => {
      if (result) {
        this.FoodSafetyManualCompleteChecklist = result;
        this.FoodSafetyManualCompleteChecklistData = JSON.parse(
          this.FoodSafetyManualCompleteChecklist.CheckListData
        );
        this.showLoader = false;
        this.Location.back();
      }
    });
  }

  Saveforlater() {
    this.FoodSafetyManualCompleteChecklist.CheckListData = JSON.stringify(
      this.FoodSafetyManualCompleteChecklistData
    );
    if (this.featureKey && this.route.snapshot.url[1].path === 'new') {
      this.FoodSafetyManualCompleteChecklist.CreatedBy = BaseServices.UserId;
    } else {
      this.FoodSafetyManualCompleteChecklist.ModifiedBy = BaseServices.UserId;
    }
    if (this.featureKey) {
      this.confirmationService.confirm({
        message: this.translate.instant('MANUALCONTROL_SAVED_LATER'),
        accept: () => {
          this.showLoader = true;
          this.subscriptions.push(
            this.manualControlService
              .createCompleteChecklist(this.FoodSafetyManualCompleteChecklist)
              .subscribe(result => {
                if (result) {
                  this.notifications.success('UI_NOTIFICATIONS.SAVED');
                  this.showLoader = false;
                  this.Location.back();
                }
              })
          );
        }
      });
    } else {
      this.confirmationService.confirm({
        message: this.translate.instant('FS_SAVED_LATER'),
        accept: () => {
          this.showLoader = true;
          this.subscriptions.push(
            this.foodSafetyService
              .createCompleteChecklist(this.FoodSafetyManualCompleteChecklist)
              .subscribe(result => {
                if (result) {
                  this.notifications.success('UI_NOTIFICATIONS.SAVED');
                  this.showLoader = false;
                  this.router.navigate(['../../../archive/list'], {
                    relativeTo: this.route
                  });
                }
              })
          );
        }
      });
    }
  }

  checkValid() {
    let val = false;
    if (this.FoodSafetyManualCompleteChecklistData) {
      for (let section of this.FoodSafetyManualCompleteChecklistData) {
        let status = section.Status;
        if (
          status[0].Value == false &&
          status[1].Value == false &&
          status[2].Value == false
        ) {
          val = true;
        }
      }
    }
    return val;
  }

  goBackPreviousPage() {
    this.Location.back();
  }

  ngOnDestroy() {
    this.draftChanges.complete();
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
}
